import useTrackEvent from '@/application/write/analytics/useTrackEvent';
import Button from '@/components/elements/Button';
import { Icons } from '@/components/elements/Icon';
import { URLS } from '@/presentation/utils/urls';

export const BountyButton = ({ className }: { className?: string }) => {
  const trackEvent = useTrackEvent();

  return (
    <Button
      href={URLS.IMMUNEFI}
      icon={Icons.BUG}
      target="_blank"
      className={className}
      onClick={() => {
        trackEvent('bug_bounty_clicked');
      }}
    >
      <span className="text-white">Bug Bounty</span>
    </Button>
  );
};
